import React, { Component } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themesNoAnimated from '@amcharts/amcharts4/themes/amcharts';
import { IChartProps } from '../../typings/chart';
import guid from '../../generic/Guid';
// import am4themesMaterial from '@amcharts/amcharts4/themes/material';
import { debounce } from 'underscore';
import styles from './Chart.module.scss';
import { Loading } from '../Loading/Loading';
import './amchart.css';
import { isEqual } from 'lodash';

am4core.useTheme(am4themesNoAnimated);
//am4core.options.minPolylineStep = 0;
// am4core.options.commercialLicense = true;
am4core.options.queue = true;

export default class LineChart extends Component<
  IChartProps,
  { loading: boolean }
> {
  amChart!: am4charts.XYChart;
  GUID = guid();
  constructor(props: any) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {
    this.createChart();
    this.createSeries();
    this.updateChartData();
  }

  componentWillUnmount() {
    if (this.amChart) {
      this.amChart.dispose();
    }
  }

  componentDidUpdate(oldProps: IChartProps) {
    if (!isEqual(oldProps.data, this.props.data)) {
      this.updateChartData();
    }
    if (!isEqual(oldProps.name, this.props.name)) {
      this.updateSeriesName();
    }
  }

  createChart = () => {
    const chart = am4core.create(this.GUID, am4charts.XYChart);
    chart.responsive.enabled = true;
    chart.cursor = new am4charts.XYCursor();
    chart.zoomOutButton.scale = 0.5;

    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.labels.template.fontSize = '10px';
    dateAxis.renderer.minGridDistance = 54;
    dateAxis.title.text = 'Time';
    dateAxis.groupData = false; // Do not improve performance by data aggregation
    // dateAxis.groupCount = 2000; // if groupData we need to set maximum number of data items we allow to be displayed at a time

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minLabelPosition = 0.01;
    valueAxis.renderer.labels.template.fontSize = '10px';
    valueAxis.renderer.minGridDistance = 50;
    valueAxis.title.text = this.props.name;

    chart.events.on('ready', () => {
      valueAxis.start = 0;
      valueAxis.end = 1;
      this.setState({ loading: false });
    });
    this.amChart = chart;
  };

  createSeries = () => {
    const series = this.amChart.series.push(new am4charts.LineSeries());
    series.stroke = am4core.color('#51628f');
    series.dataFields.dateX = 'Time';
    series.dataFields.valueY = 'Value';
    series.name = this.props.name;
    series.strokeWidth = 2;
    series.tooltipText = `{name}:[bold] {valueY}`;
    /*     series.tensionX = 1; not needed as it is the default value
    series.tensionY = 1; */
    series.fillOpacity = 0;
  };

  updateSeriesName = () => {
    const yAxis = this.amChart.yAxes.getIndex(0);
    if (yAxis !== undefined) {
      yAxis!.title.text = this.props.name;
    }
    const series = this.amChart.series.getIndex(0);
    if (series !== undefined) {
      series!.name = this.props.name;
    }
  };

  exportChartAsImage = () => {
    this.amChart.exporting.getImage("jpg").then((imgData) => {
      const link = document.createElement("a");
      link.href = imgData;
      link.download = `${this.props.downloadName}.jpg` ?? 'Downloaded Chart'
      link.click();
    });
  };

  updateChartData = debounce(() => {
    if (this.amChart.data !== this.props.data) {
      this.amChart.data = this.props.data;
    }
  }, 50);

  render() {
    return (
      <div className={styles.root} id={this.GUID}>
        <Loading loading={this.state.loading}></Loading>
      </div>
    );
  }
}
